import React from "react"
import BrandSection from "./brand_section"
import CtaCard from "./cta_card"
import LinkColumns from "./link_columns"

const STYLES = {
  footer: "flex w-full flex-row items-start justify-between bg-neutral-900 px-[60px] py-[30px] text-left",
  ctaContainer: "flex flex-col items-center",
} as const

const VenueFooterDesktop: React.FC = () => (
  <footer className={STYLES.footer} data-testid="public-venue-footer">
    <BrandSection align="start" />
    <div className={STYLES.ctaContainer}>
      <CtaCard variant="desktop" />
    </div>
    <LinkColumns />
  </footer>
)

export default VenueFooterDesktop
